const restoreSymbolsFromDmn = (value: string): string => {
  return value
    .replace(/&gt;=/g, '>=')
    .replace(/&lt;=/g, '<=')
    .replace(/&gt;/g, '>')
    .replace(/&lt;/g, '<')
    .replace(/=/g, '=')
    .replace(/\.{2}/g, ' to ')
    .replace(/not\((.*?)\)/g, (_, inner) => `not ${inner.replace(/'/g, '')}`);
};

export default restoreSymbolsFromDmn;
